export default function Expander() {
  return <span className="grow" />;
}
